import axios from "axios";

import { getToken } from "@/utils/tokenStorage";

const API = "/api";
const cfg = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const listarFormas = async () => (await axios.get(`${API}/payment-methods`, cfg())).data || [];
export const criarForma = async (payload) => (await axios.post(`${API}/payment-methods`, payload, cfg())).data;
export const atualizarForma = async (id, payload) => (await axios.put(`${API}/payment-methods/${id}`, payload, cfg())).data;

export const listarTaxas = async () => (await axios.get(`${API}/taxas-pagamento`, cfg())).data || { formas: [], canais: [] };
export const gravarTaxa = async (chave, valores) =>
  (await axios.put(`${API}/taxas-pagamento/${encodeURIComponent(chave)}`, valores, cfg())).data;

/** Detail do FastAPI (string, ou lista do 422) → texto para o toast. */
export function mensagemDeErro(e, padrao) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return padrao;
}
